<div class="flex flex-col">
  <!--Filter Section-->

  <div class="table-filter-header">
    <div *ngIf="tableName">
      <h1 class="table-name" [ngClass]="tableNameOptions">
        {{ tableName }}
      </h1>
    </div>
    <ng-template stineComponentHost></ng-template>
  </div>

  <!--Main Table-->
  <div class="table-container" [ngClass]="options.containerClass">
    <table
      mat-table
      [dataSource]="totalRecords || 0 > 0 ? data : []"
      multiTemplateDataRows
      [ngClass]="options.useElevation ? 'mat-elevation-z2' : ''"
      matSort
      [matSortDisabled]="!options.sortable"
      (matSortChange)="onSortChange($event)"
      class="no-margin"
      *ngIf="renderTable"
    >
      <!-- [matSortActive]="tableParameters.sort"
      [matSortDirection]="!tableParameters.descending ? 'desc' : 'asc'" -->
      <!-- Adding mat-sort-header directive based on column definition -->
      <ng-container
        *ngFor="let col of columns"
        [matColumnDef]="col.definition"
        [sticky]="col.options?.isSticky || false"
        class="custom-column-width"
      >
        <ng-container *ngIf="col.sortable; else noSort">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [id]="col.header"
            [style]="col.getStyle()"
          >
            <div>{{ col.header }}</div>
          </th>
        </ng-container>

        <ng-template #noSort>
          <th
            mat-header-cell
            *matHeaderCellDef
            [id]="col.header"
            [style]="col.getStyle()"
            [ngClass]="
              columnIsCheckBoxType(col) ? '!text-center' : '!text-left'
            "
          >
            <div
              *ngIf="
                !columnIsCheckBoxType(col) ||
                (columnIsCheckBoxType(col) && col.showHeaderText)
              "
            >
              {{ col.header }}
            </div>
            <div *ngIf="columnIsCheckBoxType(col) && !col.showHeaderText">
              <mat-checkbox
                [disabled]="col.disabled"
                (click)="$event.stopPropagation()"
                (change)="col.checkAllboxes($event, data)"
                [checked]="col.isAllChecked"
                [value]
              >
              </mat-checkbox>
            </div>
          </th>
        </ng-template>

        <td
          mat-cell
          *matCellDef="let row"
          [style]="col.getStyle(row)"
          [matTooltip]="col.options.toolTip ? col.options.toolTip(row) : ''"
          matTooltipPosition="right"
          id="row.id"
        >
          {{ col.toolTip }}
          @if (checkForLink(col, row)) {
            <div
              (click)="handleLinkClick($event, col.link(row))"
              class="text-blue-400 underline cursor-pointer"
            >
              {{ col.display(row) }}
            </div>
          } @else if (
            checkForInnerHtml(col) && checkForClickableContent(col, row)
          ) {
            <!-- Handle clickable HTML content -->
            <div (click)="handleColumnClick(col, row)">
              <div [innerHTML]="sanitizeInnerHtml(col, row)"></div>
            </div>
          } @else if (checkForInnerHtml(col)) {
            <!-- Handle non-clickable HTML content -->
            <div [innerHTML]="sanitizeInnerHtml(col, row)"></div>
          } @else {
            <div>
              {{ col.display ? col.display(row) : '' }}
            </div>
          }

          <div *ngIf="columnIsRadioType(col)">
            <mat-radio-button
              [disabled]="col.disabled"
              (click)="
                col.disabled
                  ? $event.stopPropagation()
                  : col.clickHandler($event, row.id, row)
              "
              [checked]="col.showChecked(row.id)"
              [value]="row.id"
            >
            </mat-radio-button>
          </div>

          <div *ngIf="columnIsCheckBoxType(col)">
            <mat-checkbox
              [disabled]="col.disabled"
              (click)="$event.stopPropagation()"
              (change)="col.disabled ? null : col.clickHandler($event, row.id)"
              [checked]="col.showChecked(row)"
              [value]="row.id"
            >
            </mat-checkbox>
          </div>

          <div *ngIf="columnIsIconType(col)">
            <mat-icon *ngIf="col.showIcon(row)" [style]="col.iconStyle">{{
              col.icon(row)
            }}</mat-icon>
          </div>

          <div *ngIf="columnIsInputType(col)">
            <input
              class="w-full p-1 border rounded border-gray-300 text-right"
              [placeholder]="col.options?.placeholder || ''"
              [(ngModel)]="row[col.definition]"
              (ngModelChange)="col.onInputChange?.($event, row)"
              stineNumberField
            />
          </div>
        </td>

        <!-- Row footer -->
        <ng-container *ngIf="options.showTotalsRow">
          <td mat-footer-cell *matFooterCellDef [style]="col.getStyle()">
            <!-- Check if the column should show "Total" text -->
            <ng-container *ngIf="options.showTotalsRow">
              <ng-container *ngIf="col.options?.showTotalText">
                <span class="footer-totals">Totals</span>
              </ng-container>
              <ng-container *ngIf="!col.options?.showTotalText">
                <!-- Displays the total value -->
                <span class="footer-totals">{{
                  totalRowData[col.definition]
                }}</span>
              </ng-container>
            </ng-container>
            <!-- If the column should not be totaled, display an empty cell -->
            <ng-container *ngIf="!col.options?.showTotal"> </ng-container>
          </td>
        </ng-container>
      </ng-container>

      <!--Action Buttons Column-->
      <div>{{ actionButtons }} | json</div>
      <ng-container *ngIf="actionButtons?.length || 0 > 0">
        <ng-container matColumnDef="actions">
          <th
            *matHeaderCellDef
            mat-header-cell
            style="width: 2px !important"
          ></th>
          <td *matCellDef="let row; let i = dataIndex" mat-cell>
            <div class="flex flex-row gap-2 justify-end">
              <button
                (click)="
                  button.callback($event, row, i); $event.stopPropagation()
                "
                class="!p-0 !h-[32px]"
                *ngFor="let button of actionButtons"
                [disabled]="button.disabled(row) || false"
                [hidden]="button.hide(row) || false"
                [id]="button.icon"
                [ngClass]="{
                  'icon-button-small': true,
                  'icon-button-small-red': button.icon === 'move_down',
                  'icon-button-small-yellow':
                    button.icon === 'insert_drive_file',
                }"
                mat-icon-button
                type="button"
                [matTooltip]="button.tooltip"
              >
                @if (button.icon) {
                  <div [ngClass]="button.classname">
                    <mat-icon>{{ button.icon }}</mat-icon>
                  </div>
                } @else {
                  <div class="button-wrapper">
                    {{ button.title }}
                  </div>
                }
              </button>
            </div>
          </td>
          <!-- Row footer for action column, default value is empty -->
          <ng-container *ngIf="options.showTotalsRow">
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
        </ng-container>
      </ng-container>

      <!--Expanded row template placeholder, pass it a context of Row-->
      <ng-container *ngIf="expandColumn">
        <ng-container matColumnDef="expandedRowColumn">
          <td
            mat-cell
            *matCellDef="let row"
            [colSpan]="expandColumn.colSpan || calculateColSpan()"
          >
            <div
              class="expanded-column"
              [@.disabled]="options.alwaysExpanded"
              [@expand]="
                row === expandedRow || options.alwaysExpanded
                  ? 'expanded'
                  : 'collapsed'
              "
            >
              <ng-template
                [ngTemplateOutlet]="expandedTemplateRef"
                [ngTemplateOutletContext]="{ $implicit: row }"
              >
              </ng-template>
            </div>
          </td>
          <!-- Row footer for expanded row, default value is empty -->
          <ng-container *ngIf="options.showTotalsRow">
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
        </ng-container>

        <ng-container matColumnDef="expandSpacer" *ngIf="expandColumn?.colSkip">
          <td
            mat-cell
            *matCellDef="let row"
            [colSpan]="expandColumn.colSkip || 0"
          ></td>
        </ng-container>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="columnsToDisplay; sticky: options.stickyHeader"
        [ngStyle]="{ display: options.showHeader ? '' : 'none' }"
        class="!leading-tight"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: columnsToDisplay"
        class="primary-row"
        [class.expandable-row]="
          (expandedRow === row && expandColumn) || row.iS_TOTAL
        "

        [ngStyle]="rowStyleFn ? rowStyleFn(row): null"

        (click)="rowClicked(row, $event)"
      ></tr>
      <ng-container *ngIf="expandColumn">
        <tr
          mat-row
          *matRowDef="let expandedRowData; columns: calcExpandColumnSkip()"
          [ngClass]="{
            'expanded-row-collapsed': !options.alwaysExpanded,
          }"
        ></tr>
      </ng-container>

      <!-- Footer row definition -->
      <ng-container *ngIf="options.showTotalsRow">
        <tr mat-footer-row *matFooterRowDef="columnsToDisplay"></tr>
      </ng-container>
    </table>
  </div>

  <!--Paginator-->
  <mat-paginator
    *ngIf="options.usePagination"
    (page)="onPageChange($event)"
    [length]="totalRecords"
    [pageSize]="pageSize"
    [showFirstLastButtons]="true"
    [pageSizeOptions]="options.pageSizeOptions"
    class="custom-paginator"
  >
  </mat-paginator>
</div>
